import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { editViolationByIdFailed, editViolationByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* editViolationById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }

    const payload = action.payload || {};
    const form = new FormData();
    ['status', 'vehicle_id', 'provider_id', 'violation_type', 'description', 'inspector_id'].forEach(key => {
      if (typeof payload[key] !== 'undefined' && payload[key] !== null && (key === 'description' || payload[key] !== '')) {
        form.append(key, payload[key]);
      }
    });

    if (payload.location) {
      form.append('location', typeof payload.location === 'string' ? payload.location : JSON.stringify(payload.location));
    }

    if (Array.isArray(payload.photos)) {
      payload.photos.forEach(photo => {
        form.append('photos', photo);
      });
    }

    const pool = form;
    const url = `${BACKEND_URL}/violations/${action.payload.id}`;
    const response = yield makeRequest(url, pool, action, 'PATCH', true, {}, true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(editViolationByIdSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(editViolationByIdFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(editViolationByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
